import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from '../services/app-insights.service';
import { AppConstants, shellApis } from './../appConstant';

@Injectable()
export class AccessDeniedInterceptor implements HttpInterceptor {
    // ToDo: PKB -- Handle Service calling error messages
    // @Output() fireUnAuthorize401ErrorMessage: EventEmitter<string> = new EventEmitter();

    constructor(
        private readonly appInsightsService: AppInsightsService,
        private readonly router: Router
    ) {
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
          AppConstants.formDirty = false;
         }, (err: HttpErrorResponse) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                    if (AppConstants.pingUserUrl !== err.url) {
                        // If the API that produced the error is an API being called in the shell service,
                        // then no action is needed, as the shell service will handle the error.
                        // Otherwise, navigate to the unauthorized page.
                        if(this.isNotShellApi(err)) {
                            this.router.navigateByUrl('/unauthorized');
                        }
                    }
                }
                if (environment.production) {
                    const error = new Error(err.message);
                    error.name = err.url;
                    this.appInsightsService.logError(error, { data: JSON.stringify({ url: err.url, message: err.message }) });
                }
            }

        }));
    }

    isNotShellApi(err: HttpErrorResponse): boolean {
        return !shellApis.some((api) => err.url.includes(api));
    }
}
